import { BaseClaraForPlannersEventTracking } from '@/modules/ai/models/segmentevents/BaseClaraForPlannersEventTracking';
import { SegmentEvent } from '/@/integrations/segment/SegmentEvent';
import { ClaraEscalationBranch } from '@/modules/ai/constants/ClaraEscalationBranch';
import type { AuthUser } from '@/modules/auth/models/AuthUser';
import type { ClaraMessageObject } from '@/modules/ai/models/ClaraMessageObject';

export class ClaraForPlannersResponseGeneratedEventTracking extends BaseClaraForPlannersEventTracking {
  static eventName: string = SegmentEvent.CLARA_RESPONSE_GENERATED;

  answered: boolean;
  grounded: boolean;
  responseTimeMs: number;
  servedJurisdiction: string | null;
  servedPlan: string | null;

  constructor(
    authUser: AuthUser | null,
    sessionId: string,
    answer: ClaraMessageObject | undefined,
    responseTimeMs: number
  ) {
    super(authUser, sessionId);
    const branch: string | undefined = answer?.escalation?.branch;

    this.answered = !!answer?.isSuccess && (!branch || branch === ClaraEscalationBranch.ANSWER);
    this.grounded = this.answered && !!answer?.similarityData?.length;
    this.responseTimeMs = responseTimeMs;
    this.servedJurisdiction = null;
    this.servedPlan = null;
  }
}
